import {type BoardInitialPayload, type BoardPayloadItem, toBoardData as toBoardDataShape} from './issues/board-payload'
import type {SavedViewsBoardData} from './types'

/**
 * Maps a payload into everything the host needs: the board `data` and the axis field
 * identifiers that drive grouping. Pure — no React, no fetch, no domain rules.
 *
 * The `data` mapping is delegated to the payload module's `toBoardData`, so the D16
 * discipline — four stated axis booleans, per-cell `totalCount`/`hasMoreItems` carried
 * rather than inferred from `items.length` — lives in exactly one place.
 */
export function toBoardData(payload: BoardInitialPayload): SavedViewsBoardData<BoardPayloadItem> {
  return {
    data: toBoardDataShape(payload),
    columnField: payload.columnField,
    rowField: payload.rowField,
  }
}
